import Header from "@/reusable_sections/Header";
import ParlonsDeVosBesoins from "./sections/ParlonsDeVosBesoins";
import GlobalAvailability from "./sections/GlobalAvailability";
import Footer from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div>
      <Header />
      <ParlonsDeVosBesoins />
      <GlobalAvailability />
      <Footer />
    </div>;
}